import { onClickMessageExtensionFlyoutButton } from '../actions/onClickMessageExtensionFlyoutButton';
import type { AppButtonOnExecuteParameter } from 'owa-acui';
import type { MailboxInfo } from 'owa-client-types';
import type { MessageExtensionType } from 'owa-graph-schema';

export function messageExtensionsRibbonButtonOnExecute(
    params: AppButtonOnExecuteParameter,
    targetWindow: Window,
    formId: string,
    messageExtensionType: MessageExtensionType,
    mailboxInfo?: MailboxInfo,
    readingPaneItemId?: string
): void {
    if (!params.location) {
        return;
    }

    onClickMessageExtensionFlyoutButton({
        flyoutButtonElementId: params.id,
        targetWindow,
        formId,
        readingPaneItemId: readingPaneItemId ?? '',
        messageExtensionType,
        mailboxInfo,
    });
}
